import React from 'react';

type AdminPageAddCreditsModalProps = {
  userName: string;
  amount: string;
  onAmountChange: (v: string) => void;
  description: string;
  onDescriptionChange: (v: string) => void;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
};

const AdminPageAddCreditsModal: React.FC<AdminPageAddCreditsModalProps> = ({
  userName,
  amount,
  onAmountChange,
  description,
  onDescriptionChange,
  onClose,
  onConfirm,
  loading,
}) => (
  <div className="admin-page-modal-overlay">
    <div className="admin-page-modal">
      <div className="admin-page-modal-header">
        <div>
          <h3 className="admin-page-modal-title">Add credits</h3>
          <p className="admin-page-modal-subtitle mt-1">Add credits to {userName}</p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="admin-page-modal-close"
          aria-label="Close modal"
          disabled={loading}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="admin-page-modal-body space-y-4">
        <div>
          <label className="admin-page-modal-label-block">Amount</label>
          <input
            type="number"
            min={1}
            value={amount}
            onChange={(e) => onAmountChange(e.target.value)}
            className="admin-page-modal-input"
            placeholder="e.g. 50"
            disabled={loading}
          />
        </div>
        <div>
          <label className="admin-page-modal-label-block">Description (optional)</label>
          <input
            type="text"
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
            className="admin-page-modal-input"
            placeholder="e.g. Promotional credits"
            disabled={loading}
          />
        </div>
      </div>
      <div className="admin-page-modal-actions">
        <button type="button" onClick={onClose} className="admin-page-modal-btn admin-page-modal-btn-cancel" disabled={loading}>
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading || !amount.trim()}
          className="admin-page-modal-btn admin-page-modal-btn-primary"
        >
          {loading ? 'Adding...' : 'Add credits'}
        </button>
      </div>
    </div>
  </div>
);

export default AdminPageAddCreditsModal;
